<div class="content client-list">
  <div class="content-body">
    <p class="header-text d-flex justify-space-between align-items-center">
      Show Journals
      <button
      mat-button
      class="header-text-close d-flex align-items-center"
      disableRipple
      (click)="onCloseClick()"
      >
      <mat-icon>close</mat-icon>
      </button>
    </p>

    <div class="year-picker mb-1">
      <div class="d-flex align-items-center justify-space-between line">
        <div class="d-flex align-items-center is-readonly">
        <span class="fw-bold mr-1">Period:</span>
        <app-custom-year-picker [moduleId]="moduleId"
          (triggerDateChange)="triggerDateChange($event)"></app-custom-year-picker>
        </div>
          <div
    class="content-right-button d-flex align-items-center"
  >
    <button     class="action-button primary-button m-0"  mat-button
    disableRipple  (click)="addJournal()">Add New Journal</button>
    </div>
      </div>
    </div>
    
    <div class="mat-table-wrapper">
        <table
            mat-table
            [dataSource]="jurnalsList"
          
            aria-describedby="User details table"
            class="grid-table"
          >
              <ng-container matColumnDef="vno">
            <th mat-header-cell  *matHeaderCellDef class="w-230">
              Ref NO
            </th>
            <td mat-cell *matCellDef="let data; let i = index">
              <div class="d-flex align-items-center justify-space-between">
                <div class="clamp">
                  <a
                  
                    class="hyperlink"
                    
                  >
                    {{data?.vno }}
                  </a>

                  
                </div>
               
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell  *matHeaderCellDef class="w-230">
             Is Balanced
            </th>
            <td mat-cell *matCellDef="let data; let i = index" class="status">
              <div class="d-flex align-items-center justify-space-between">
                <div class="clamp"  [ngClass]="{
                    'status-active': (data?.isbalanced),
                    'status-archived': !(data?.isbalanced)
                  }">
                 
                    {{(data?.isbalanced)?'Yes':'No' }}
                 

                  
                </div>
                <div
                  class="grid-actions"
                
                >
                  <div
                    class="d-flex align-items-center"
                    
                  >
                    <button
                      
                      mat-button
                      disableRipple
                    
                      (click)="editClick(data?.id)"
                      
                    >
                      <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                    </button>
                    <button
                      
                    mat-button
                    disableRipple
                  
                    (click)="deleteClick(data?.id)"
                    
                  >
                    <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
                  </button>
                  
                  </div>
              
                </div>
              </div>
            </td>
          </ng-container>
          <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let i = index"
          
        ></tr>
        </table>
    </div>

  </div>
</div>    





